import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Spinner } from '@ds';
import { ActiveGroundTripWarning } from './ActiveGroundTripWarning';

export type RemoveResourceModalProps = {
  resourceId: string;
  title: string;
  description: string;
  isOpen: boolean;
  isLoading: boolean;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onRemove: () => void;
  onClose: () => void;
};

export const RemoveResourceModal = ({
  resourceId,
  title,
  description,
  isOpen,
  isLoading,
  size = 'md',
  onRemove,
  onClose,
}: RemoveResourceModalProps) => {
  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      hideCloseButton
      classNames={{
        base: 'px-6',
        body: 'border-y-1 border-base-30 px-0 py-6 text-l-r',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-6',
        wrapper: 'z-420',
        backdrop: 'z-419',
      }}
    >
      <ModalContent>
        {(handleClose) => (
          <>
            {isLoading && (
              <div className="absolute top-0 left-0 flex justify-center items-center z-50 w-full h-full bg-white bg-opacity-40">
                <Spinner size="md" />
              </div>
            )}
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>
              <div className="flex flex-col gap-2">
                <ActiveGroundTripWarning resourceId={resourceId} />
                <span className="text-m-r text-base-5">{description}</span>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button size="md" variant="outline" onClick={handleClose}>
                Discard
              </Button>
              <Button isDisabled={isLoading} size="md" color="default" variant="solid" onClick={onRemove}>
                Remove
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
